import {post} from './axios';

function sendEmail(data){
    return post('/api/email/', data);
}

export default { sendEmail };